import React from 'react';
import { InfoCard } from '@backstage/core-components';
import { Box, Link, Typography } from '@material-ui/core';
import { GitlabIcon } from '../../icons/GitlabIcon';

const SERVICE_PORTAL_URL =
  'https://serviceportal.netrtl.com/mgrtl?id=sc_cat_item&table=sc_cat_item&sys_id=7db398682b51c714bffaf382ce91bf0a&recordUrl=com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1&sysparm_id=7db398682b51c714bffaf382ce91bf0a';

export const LicensesCard = () => {
  return (
    <InfoCard title="Licenses" variant="gridItem">
      <Box display="flex" alignItems="center" style={{ padding: 16 }}>
        <GitlabIcon />
        <Typography style={{ marginLeft: 8 }}>
          Licenses for GitLab On-Premises and GitLab SaaS are now managed via
          the{' '}
          <Link
            href={SERVICE_PORTAL_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Service Portal
          </Link>
          .
        </Typography>
      </Box>
    </InfoCard>
  );
};
